export const FIELD_WIDTH = "320px"; // The helper text for float and currency field type is the longest. We want to align all fields to be with the same width.
